module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.record) ? _c('div', {
    staticClass: "mdl-grid"
  }, [_c('h3', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [(_vm.record.changed) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.record.product.name) + " "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "subheader"
  }, [(_vm.record.product.variety) ? [_vm._v(_vm._s(_vm.record.product.variety) + ",")] : _vm._e(), _vm._v("\n        " + _vm._s(_vm.record.product.origin) + ",\n        " + _vm._s(_vm.record.product.unit) + "\n    ")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--6-col-tablet"
  }, [_c('h4', [_vm._v("Ceny do publikacji")]), _vm._v(" "), _vm._l((_vm.record.draftPrices), function(price, index) {
    return _c('div', [_c('currency-input', {
      staticClass: "bigger-font",
      nativeOn: {
        "input": function($event) {
          _vm.priceChanged($event)
        }
      },
      model: {
        value: (price.price),
        callback: function($$v) {
          price.price = $$v
        },
        expression: "price.price"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab",
      on: {
        "click": function($event) {
          _vm.removeDraftPrice(_vm.record, index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored",
    on: {
      "click": function($event) {
        _vm.addDraftPrice(_vm.record)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--6-col-tablet"
  }, [_c('h4', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("Ceny z poprzedniego notowania")]), _vm._v(" "), _vm._l((_vm.record.previousPrices), function(price) {
    return _c('div', [_vm._v("\n      " + _vm._s(_vm._f("currency")(price.price)) + "\n    ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.usePreviousPrices($event)
      }
    }
  }, [_vm._v("\n        Użyj cen z poprzedniego notowania\n    ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--6-col-tablet"
  }, [_c('h4', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("Ceny opublikowane")]), _vm._v(" "), _vm._l((_vm.record.publicPrices), function(price) {
    return _c('div', [_vm._v("\n      " + _vm._s(_vm._f("currency")(price.price)) + "\n    ")])
  })], 2)]) : _c('my-spinner')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24a070e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecordEdit.vue
// module id = 259
// module chunks = 1